import {AfterViewInit, Component, DestroyRef, DoCheck, Input, NgZone, OnInit} from '@angular/core';
import {CommonModule, NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {LookupService} from '../../../../../common/service/lookup.service';
import {FeatureViewerItemLookup} from '../../../../../common/models/feature-viewer-item.model';
import {TraitsService} from '../../../../../common/service/traits.service';
import {NgEventBus} from 'ng-event-bus';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {PlanModelService} from '../../../../../common/service/plan-model.service';
import {FeatureTableComponent} from './feature-table/feature-table.component';
import {NLR_TABS} from '../../../../../common/constants';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Component({
    selector: 'nlr-geometry-tab',
    imports: [CommonModule, FormsModule, FeatureTableComponent],
    providers: [CommonModule],
    templateUrl: './geometry-tab.component.html',
    styleUrl: './geometry-tab.component.scss'
})
export class GeometryTabComponent implements OnInit, DoCheck {
    @Input()
    editorConfig: any;

    @Input()
    disabled: boolean;

    @Input()
    selectedTab: NLR_TABS;

    title = 'GeometryTabComponent';

    selectedFeatureTableTool: FeatureViewerItemLookup;

    toolRows: [{tools: FeatureViewerItemLookup[]}] = [{tools: []}];

    isDesignTabActive: boolean = true;

    previousSelectedTab: NLR_TABS = undefined;

    constructor(
        private destroyRef: DestroyRef,
        private eventBus: NgEventBus,
        private lookupService: LookupService,
        private planModelService: PlanModelService,
        private traitsService: TraitsService
    ) {}

    ngDoCheck(): void {
        if (this.selectedTab !== this.previousSelectedTab) {
            this.previousSelectedTab = this.selectedTab;
            this.isDesignTabActive = this.selectedTab === NLR_TABS.DESIGN;
        }
    }

    ngOnInit() {
        this.eventBus
            .on('traitsChanged')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                if (!this.planModelService.getModel().planPurpose || !this.planModelService.getModel().surveyMethod) {
                    return;
                }

                this.populateTools();
            });

        this.populateTools();
    }

    changeSelectedFeatureTableTool(tool: any) {
        console.debug(`${this.title} - changeSelectedFeatureTableTool`);
        this.selectedFeatureTableTool = tool;
        this.eventBus.cast(`moveTo${this.selectedFeatureTableTool.type}FeaturesExtent`);
    }

    populateTools() {
        console.debug(`${this.title} - populateTools`);

        const featureViewerItemLookups = this.lookupService
            .getLookups('featureViewerItem')
            .filter((l: FeatureViewerItemLookup) => l.view === 'geometry' && this.traitsService.criteriaMatches(l.planTraitCriteria, true))
            .sort((a: FeatureViewerItemLookup, b: FeatureViewerItemLookup) => {
                if (a.row === b.row) {
                    return a.order - b.order;
                }
                return a.row - b.row;
            });

        this.toolRows.splice(0, this.toolRows.length, {tools: []});

        featureViewerItemLookups.forEach((tool: FeatureViewerItemLookup) => {
            if (this.toolRows.length >= tool.row) {
                this.toolRows[tool.row - 1].tools.push(tool);
            } else {
                this.toolRows.push({tools: [tool]});
            }

            // set the default selection
            if (tool.defaultSelection) {
                this.selectedFeatureTableTool = tool;
            }
        });
    }
}
